const WarningSVG = () => (
    <svg
        width="20px"
        height="20px"
        style={{
            height: "20px",
            width: "20px",
        }}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 15H12.01M12 12V9M4.98207 19H19.0179C20.5615 19 21.5233 17.3256 20.7455 15.9923L13.7276 3.96153C12.9558 2.63852 11.0442 2.63852 10.2724 3.96153L3.25452 15.9923C2.47675 17.3256 3.43849 19 4.98207 19Z"
            stroke="#000000"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const PreviewBanner = () => {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: 14,
                padding: "10px 14px",
                backgroundColor: "#ffb800",
                margin: "10px auto",
                borderRadius: 8,
            }}
        >
            <span style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                <WarningSVG />
            </span>
            <p
                style={{
                    margin: 0,
                    padding: 0,
                    color: "#000",
                    fontSize: 12,
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "1.1",
                }}
            >
                This bundle is visible only to you. Discounts will not apply in cart or checkout until published.
            </p>
        </div>
    );
};

export default PreviewBanner;
